import React, { useMemo } from "react";
import { inject, observer } from "mobx-react";
import { Option } from "../../../../common/forms/Interfaces";
import SelectFilter from "../selectFilter";
import { IFilterProps, IFilterWithStoreProps } from "../Interfaces";

const CreatorFilter: React.FC<IFilterWithStoreProps> = inject("store")(
  observer(
    ({
      setSelectedKeys,
      confirm,
      clearFilters,
      store,
      selectedKeys,
      multiple,
    }) => {
      const settingsStore = store?.settingsStore;
      const options = useMemo(
        (): Option[] =>
          settingsStore?.creators
            ? settingsStore?.creators.map(
                (creator: Option): Option => ({
                  value: creator.extra as string,
                  title: creator.title,
                })
              )
            : [],
        [settingsStore]
      );

      return (
        <SelectFilter
          setSelectedKeys={setSelectedKeys}
          confirm={confirm}
          clearFilters={clearFilters}
          options={options}
          selectedKeys={selectedKeys}
          multiple={multiple}
        />
      );
    }
  )
);

const Wrapper: React.FC<IFilterProps> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
  multiple,
}) => (
  <CreatorFilter
    selectedKeys={selectedKeys}
    setSelectedKeys={setSelectedKeys}
    confirm={confirm}
    clearFilters={clearFilters}
    multiple={multiple}
  />
);

export default Wrapper;
